// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".side-bar-promo-desktop__item._coupon{margin-bottom:24px}.side-bar-promo-desktop__visible-button{border:0;background-color:transparent;padding:0;font-family:inherit;color:inherit;font-size:16px;line-height:24px;color:#3d70b2;text-align:left;display:flex;align-items:center;justify-content:center;padding:10px 0}.side-bar-promo-desktop__visible-button:not(:disabled){cursor:pointer}", ""]);
// Exports
module.exports = exports;
